var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdStyles } from "../../../../../../less/IdStyles";
import { actionBeginBuyWithGoldProcess } from "../../../../../buy-with-gold/actionBuyWithGold";
import { Icon } from "../../../../../generic/icon/Icon";
import { IdIcon } from "../../../../../generic/icon/IdIcon";
import { actionModalSwapLast } from "../../../../../modals/actionModal";
import { IdModal } from "../../../../../modals/IdModal";
import { ButtonQuestShowMe } from "../ButtonQuestShowMe";
import { QuestSkipButton } from "../QuestSkipButton";
import { QuestTask } from "../QuestTask";
var _QuestTaskChoosePlayerName = function (props) {
    var tasks = props.tasks, quest = props.quest, questInfoTasks = props.questInfoTasks, onTrySkip = props.onTrySkip, onShowMe = props.onShowMe;
    var task = tasks;
    var list = task.map(function (value) {
        var icon = React.createElement(Icon, { icon: IdIcon.PenIcn, styleId: IdStyles.IconExtraLarge });
        var requiredInfoTask = questInfoTasks.find(function (val) { return val.index === value.index; });
        var currentAmount = requiredInfoTask.amount || 0;
        var taskCompleted = currentAmount >= value.amount;
        var taskProps = {
            currentAmount: currentAmount,
            icon: icon,
            locaKey: value.locaKey,
            requiredAmount: value.amount,
            taskCompleted: taskCompleted,
        };
        var skipButtonProps = {
            onTrySkip: onTrySkip,
            questId: quest.id,
            requiredAmount: value.amount,
            skipCost: value.skipCost,
            taskIndex: value.index,
        };
        return (React.createElement(QuestTask, __assign({ key: value.locaKey + "_" + icon }, taskProps),
            React.createElement(ButtonQuestShowMe, { onClick: function () {
                    onShowMe(IdModal.SetPlayerName);
                }, questTask: value }),
            React.createElement(QuestSkipButton, __assign({}, skipButtonProps))));
    });
    return React.createElement("div", { key: "choosePlayerName" }, list);
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onShowMe: actionModalSwapLast,
        onTrySkip: actionBeginBuyWithGoldProcess,
    }, dispatch);
};
export var QuestTaskChoosePlayerName = connect(undefined, mapDispatch)(_QuestTaskChoosePlayerName);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/qeustTaskChoosePlayerName/QuestTaskChoosePlayerName.tsx
// module id = 2666
// module chunks = 3